import Network from "./Network";

const GetSectionQuery = async (section) => {
    const response = await Network().get(`/public/section?type=${section}`)
    return response.data
}
export default GetSectionQuery
